/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response for password reset operation
 * @export
 * @interface PasswordResetResponse
 */
export interface PasswordResetResponse {
    /**
     * Whether the password reset was successful
     * @type {boolean}
     * @memberof PasswordResetResponse
     */
    success?: boolean;
    /**
     * User ID
     * @type {string}
     * @memberof PasswordResetResponse
     */
    userId?: string;
    /**
     * User email
     * @type {string}
     * @memberof PasswordResetResponse
     */
    email?: string;
    /**
     * New password (only returned if generated, not if provided)
     * @type {string}
     * @memberof PasswordResetResponse
     */
    newPassword?: string;
    /**
     * Whether password is temporary
     * @type {boolean}
     * @memberof PasswordResetResponse
     */
    temporaryPassword?: boolean;
    /**
     * Error message if reset failed
     * @type {string}
     * @memberof PasswordResetResponse
     */
    error?: string;
    /**
     * Message indicating result
     * @type {string}
     * @memberof PasswordResetResponse
     */
    message?: string;
}

/**
 * Check if a given object implements the PasswordResetResponse interface.
 */
export function instanceOfPasswordResetResponse(value: object): value is PasswordResetResponse {
    return true;
}

export function PasswordResetResponseFromJSON(json: any): PasswordResetResponse {
    return PasswordResetResponseFromJSONTyped(json, false);
}

export function PasswordResetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordResetResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'email': json['email'] == null ? undefined : json['email'],
        'newPassword': json['newPassword'] == null ? undefined : json['newPassword'],
        'temporaryPassword': json['temporaryPassword'] == null ? undefined : json['temporaryPassword'],
        'error': json['error'] == null ? undefined : json['error'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function PasswordResetResponseToJSON(json: any): PasswordResetResponse {
    return PasswordResetResponseToJSONTyped(json, false);
}

export function PasswordResetResponseToJSONTyped(value?: PasswordResetResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'userId': value['userId'],
        'email': value['email'],
        'newPassword': value['newPassword'],
        'temporaryPassword': value['temporaryPassword'],
        'error': value['error'],
        'message': value['message'],
    };
}

